<template>
  <div class="preview">
    <!-- <div class="weixin_mask" v-if="!isWeixin" @click="weixinMask"></div> -->

    <div class="title">大有空间App线上预约</div>
    <div class="content flex">
      <img
        class="title-img"
        src="../../assets/images/preview/pre-title.png"
        alt=""
      />

      <div class="yuanmao-box" @click="openDetail">
        <!-- <div class="yuanmao-text">798-PUNKCAT</div> -->
        <!-- <img
          class="yuanmao-img"
          src="../../assets/images/preview/yuanmao.png"
          alt=""
        /> -->
      </div>

      <div class="tips flex-center">
        集齐
        <img
          class="suipian"
          src="../../assets/images/preview/pre-7.png"
          alt=""
        />
        <img
          class="suipian"
          src="../../assets/images/preview/pre-9.png"
          alt=""
        />
        <img
          class="suipian suipian-8"
          src="../../assets/images/preview/pre-8.png"
          alt=""
        />
        3种碎片即可获得
      </div>

      <div class="pre-btn" @click="promote" v-if="!checkin_status">
        立即预约
      </div>

      <div class="pre-btn pre-btn-no" v-else>已成功预约</div>

      <div class="tips-l">预约随机获得3块碎片</div>

      <div class="other-path" v-if="checkin_status">
        <div class="invite position-top flex-center" @click="get_qrcode">
          <div class="invite-exchange flex">
            邀请好友注册赢好礼
            <img
              class="irow-right"
              src="../../assets/images/preview/irow-right.png"
              alt=""
            />
          </div>
          <div class="invite-tips">邀请1名好友可获得1个碎片，最多10个</div>
        </div>

        <div class="exchange">
          <div class="invite-exchange flex" @click="openExchangePieces">
            加入社群，与社群成员交换碎片
            <img
              class="irow-right"
              src="../../assets/images/preview/irow-right.png"
              alt=""
            />
          </div>
          <div class="invite-tips">24小时后开放</div>
        </div>
      </div>

      <img
        class="join-text"
        src="../../assets/images/preview/join-text.png"
        alt=""
      />

      <div class="qr-code flex-center">
        <img
          class="qrcode-img"
          src="../../assets/images/preview/qrcode-img.png"
          alt=""
        />
      </div>

      <div class="tips-code">长按上方二维码加入大有社群</div>

      <div class="time-box">APP上线时间 6月26日</div>

      <div class="tips-com">活动最终解释权归杭州世间乐见科技有限公司</div>
    </div>

    <div class="footer flex" v-if="checkin_status">
      <div class="footer-left flex">
        <div class="footer-left-title">我的碎片</div>
        <div class="all-suipian flex">
          <div
            class="all-suipian-item flex"
            v-for="(item, index) in list"
            :key="index"
          >
            <img class="suipian-copy" :src="item.piece_image" alt="" />
            <div class="suipian-num">{{ item.num }}个</div>
          </div>
        </div>
      </div>
      <div class="footer-right">
        <div class="all-btn" @click="hecheng">前往合成</div>
      </div>
    </div>

    <!-- 基本弹窗 -->
    <baseDialog
      v-if="dialog.isShow"
      :title="dialog.title"
      :content="dialog.content"
      @close="closeBase"
      @submit="closeBase"
    ></baseDialog>

    <!-- 底部弹窗 -->
    <bottomDialog
      @close="bottomClose"
      v-if="bottomDialog.isShow"
      :title="bottomDialog.title"
      :img="bottomDialog.img"
      :slotFlag="bottomDialog.slotFlag"
      :tips="bottomDialog.tips"
    >
      <template slot="dialog-detail" v-if="bottomDialog.slotType == 1">
        <div class="dialog-detail-top">
          <div class="dialog-detail-top-title flex-center">
            获得<img class="afterImg" :src="afterImg" alt="" />碎片
          </div>
          <div class="dialog-detail-top-content flex-center">
            给出<img class="byImg" :src="byImg" alt="" />碎片
          </div>
        </div>
        <div class="dialog-detail-bottom">
          <div class="footer flex">
            <div class="footer-left flex">
              <div class="footer-left-title">我的碎片</div>
              <div class="all-suipian flex">
                <div
                  class="all-suipian-item flex"
                  v-for="(item, index) in list"
                  :key="index"
                >
                  <img class="suipian-copy" :src="item.piece_image" alt="" />
                  <div class="suipian-num">{{ item.num }}个</div>
                </div>
              </div>
            </div>
            <div class="footer-right">
              <div class="all-btn" @click="_transfer_reply">同意</div>
            </div>
          </div>
        </div>
      </template>

      <template slot="dialog-detail" v-if="bottomDialog.slotType == 2">
        <div class="dialog-detail-box flex">
          <div class="dialog-detail-qrcode flex">
            <div class="dialog-detail-box-top">
              <img src="../../assets/images/preview/first_step.png" alt="" />
            </div>
            <div class="dialog-detail-box-content flex-center">
              <img src="../../assets/images/preview/qrcode-img.png" alt="" />
            </div>
            <div class="dialog-detail-box-bottom">长按二维码加入社群</div>
          </div>
          <div class="dialog-detail-exchange flex">
            <div class="dialog-detail-box-top">
              <img src="../../assets/images/preview/second_step.png" alt="" />
            </div>
            <div class="dialog-detail-box-btn" @click="openExchangePiecesCopy">
              +创建交换单
            </div>
            <div class="dialog-detail-box-bottom">创建交换单，转发到群里</div>
          </div>
        </div>
      </template>
    </bottomDialog>

    <Login v-if="showLogin" title="绑定手机号" @login="login"></Login>

    <getPieces
      :list="getPieces.getList"
      v-if="getPieces.isShow"
      @close="closeGetPieces"
      @submit="closeGetPieces"
    ></getPieces>

    <exchangePieces
      v-if="exchangePieces.isShow"
      @close="closeExchangePieces"
    ></exchangePieces>

    <poster v-if="poster.isShow" @close="qrCodeClose"></poster>

    <detailDialog
      v-if="detailDialog.isShow"
      @close="detailClose"
    ></detailDialog>
  </div>
</template>

<script>
import { env_is_wexin } from "../../utils/utils.js";
import {
  promoteCheckin,
  pieceslist,
  config_data,
  transfer_reply,
} from "@/api/preview.js";
import baseDialog from "@/components/dialog/baseDialog/baseDialog";
import bottomDialog from "@/components/dialog/bottomDialog/bottomDialog";
import detailDialog from "@/components/dialog/detailDialog/detailDialog";
import Login from "@/components/common/login/login";
import getPieces from "@/components/subscribe/get_pieces/get_pieces";
import exchangePieces from "@/components/subscribe/exchange_pieces/exchange_pieces";
import poster from "@/components/subscribe/poster/poster";
export default {
  components: {
    baseDialog,
    Login,
    bottomDialog,
    getPieces,
    exchangePieces,
    poster,
    detailDialog,
  },
  computed: {
    isWeixin() {
      return env_is_wexin();
    },
  },
  data() {
    return {
      isAll: true, //是否集齐
      currentTime: 0, //当前时间戳
      timestamp: 0, //app上线时间戳
      byImg: "",
      afterImg: "",
      exchangeBy: 0, //我消耗的碎片id
      exchangeAfter: 0, //我得到的碎片id
      transfer_id: 0, //交换id
      vip_code: "", //vip识别码
      from_code: "", //分享人识别码
      showLogin: false,
      dialog: {
        isShow: false,
        title: "",
        content: "",
        button: "",
      },
      bottomDialog: {
        isShow: false,
        title: "",
        img: "",
        tips: "",
        slotFlag: true, //插槽标识，true为显示插槽内容，false为默认内容
        slotType: 0, //插槽类型 用来标识不同的定制化弹窗内容
      },
      getPieces: {
        //交换弹窗
        isShow: false,
        getList: [],
      },
      exchangePieces: {
        //创建交换单弹窗
        isShow: false,
      },
      poster: {
        isShow: false,
      },
      detailDialog: {
        isShow: false,
      },
      list: [
        {
          piece_id: 7,
          num: 0,
          image: require("../../assets/images/preview/pre-7.png"),
        },
        {
          piece_id: 9,
          num: 0,
          image: require("../../assets/images/preview/pre-9.png"),
        },
        {
          piece_id: 8,
          num: 0,
          image: require("../../assets/images/preview/pre-8.png"),
        },
      ],
      isLogin: false,
      checkin_status: 0,
    };
  },
  created() {
    // if (!this.isWeixin) return;
    const token = localStorage.getItem("token") || "";
    this.checkin_status = Number(localStorage.getItem("checkin_status")) || 0;
    const { from_code } = this.$route.query;
    this.from_code = from_code;
    const query = this.$route.query;
    this.transfer_id = query.transfer_id || 0;
    this.exchangeBy = query.exchangeBy || 0;
    this.exchangeAfter = query.exchangeAfter || 0;
    if (token) {
      this.get_config_data();
      this.isLogin = true;
    } else if (this.transfer_id) {
      this.showLogin = true;
    }
  },
  methods: {
    openDetail() {
      this.detailDialog.isShow = true;
    },
    //关闭详情
    detailClose() {
      this.detailDialog.isShow = false;
    },
    //关闭海报
    qrCodeClose() {
      this.poster.isShow = false;
    },
    //获取二维码
    get_qrcode() {
      this.poster.isShow = true;
    },
    //同意碎片交换
    _transfer_reply() {
      transfer_reply({
        transfer_id: this.transfer_id,
      })
        .then(() => {
      //    console.log(res);
          this.bottomDialog.isShow = false;
          this.dialog.isShow = true;
          this.dialog.title = "交换成功";
          this.get_pieceslist();
        })
        .catch((res) => {
          this.dialog.isShow = true;
          this.dialog.title = res.msg;
        });
    },
    //判断上线时间
    isAppUp() {
      if (this.currentTime > this.timestamp) {
        this.bottomDialog.isShow = true;
        this.bottomDialog.slotFlag = false;
        this.bottomDialog.slotType = 0;
        this.bottomDialog.title = "APP已上线，下载APP直接领取！！！";
        this.bottomDialog.img = require("../../assets/images/preview/qrcode-img.png");
        this.bottomDialog.tips = "加油！距离限量punkcat仅有一步！";
      }
    },
    //获取自定义配置
    get_config_data() {
      const query = {
        tags: ["appTime"],
      };
      config_data(query).then((res) => {
        this.timestamp = new Date(res.appTime).getTime();
        this.currentTime = new Date().getTime();
        this.isAppUp();
        this.get_pieceslist();
      });
    },
    //合成
    hecheng() {
      this.list.forEach((item) => {
        if (item.num == 0) {
          this.isAll = false;
        }
      });
      if (this.isAll) {
        if (this.currentTime > this.timestamp) {
      //    console.log("app已上线");
          this.bottomDialog.isShow = true;
          this.bottomDialog.slotFlag = false;
          this.bottomDialog.title = "合成台位于APPXXX，请下载APP后合";
          this.bottomDialog.img = require("../../assets/images/preview/qrcode-img.png");
          this.bottomDialog.tips = "加油！距离限量punkcat仅有一步！";
        } else {
          this.dialog.isShow = true;
          this.dialog.title = "APP未上线，暂时无法合成";
          this.dialog.content = "*APP将于6月26日上线";
        }
      } else {
        this.dialog.isShow = true;
        this.dialog.title = "材料不足，无法合成";
      }
    },
    //关闭弹窗
    closeExchangePieces() {
      this.exchangePieces.isShow = false;
    },
    closeGetPieces() {
      this.getPieces.isShow = false;
      this.transfer_id = 0;
    },
    //打开交换单
    openExchangePiecesCopy() {
      this.exchangePieces.isShow = true;
    },
    openExchangePieces() {
      this.bottomDialog.isShow = true;
      this.bottomDialog.slotFlag = true;
      this.bottomDialog.slotType = 2;
    },
    //判断是否有交换id
    isTransfer() {
      if (this.bottomDialog.isShow || this.bottomDialog.slotType != 0) return;

      if (this.transfer_id) {
        this.list.forEach((item) => {
          if (item.piece_id == this.exchangeBy) {
            this.byImg = item.piece_image;
          }
          if (item.piece_id == this.exchangeAfter) {
            this.afterImg = item.piece_image;
          }
        });
        this.bottomDialog.isShow = true;
        this.bottomDialog.slotFlag = true;
        this.bottomDialog.slotType = 1;
      }
    },
    weixinMask() {
  //    console.log("isnoweixin");
      this.dialog.isShow = true;
      this.dialog.title = "请在微信内打开";
    },
    closeBase() {
      this.dialog.isShow = false;
    },
    //底部弹窗的关闭回调
    bottomClose() {
      this.bottomDialog.isShow = false;
      this.isTransfer();
    },
    //点击立即预约按钮
    promote() {
      if (this.isLogin) {
        this.checkin_status = localStorage.getItem("checkin_status");
        this._promoteCheckin(); // 登录成功自动领取
      } else {
        this.showLogin = true;
      }
    },
    //领取预约
    _promoteCheckin() {
      promoteCheckin({
        vip_code: this.vip_code,
        from_code: this.from_code,
      }).then((res) => {
    //    console.log(res);
        this.getPieces.getList = res.list;
        this.getPieces.isShow = true;
        this.checkin_status = 1;
        localStorage.setItem("checkin_status", 1);
        this.get_pieceslist();
        // this.list = res.list
      });
    },
    //查询碎片
    get_pieceslist() {
      pieceslist({}).then((res) => {
    //    console.log(res);
        this.list = res.list;
        this.isTransfer();
      });
    },
    // 登录
    login(status) {
      this.showLogin = false;
      this.isLogin = status;
      if (status) {
        this.checkin_status = Number(localStorage.getItem("checkin_status"));
        if (!this.checkin_status) {
          this._promoteCheckin(); // 登录成功自动领取
        } else {
          this.get_pieceslist();
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import "./preview.less";
</style>
